export default "__VITE_ASSET__DaeG_q7o__"